import React from "react"
/*import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';*/
import { graphql} from "gatsby";

import Layout from "../components/layout"
import SEO from "../components/seo"

import { LightgalleryProvider, LightgalleryItem } from "react-lightgallery";
import "../css/lightgallery.css";

import DisqusComments from '../components/DisqusComments'



const PhotoItem = ({ image, group, alt }) => (
  <div style={{  }} className="Product-Image">
    <LightgalleryItem group={group} src={image}>
      <img src={image} alt={alt} style={{  }} />
    </LightgalleryItem>
  </div>
);

const ProductDetails = data => (


  < Layout >


<div class="s9-widget-wrapper"></div>

    <SEO 
      title={data.data.product.name}
      keywords={[`Handmade`, `Crafts`, `${data.data.product.category[0].name}`, `${data.data.product.name}`]}
      ogTitle={data.data.product ? `${data.data.product.name}` : ""}
      ogURL={data.data.product ? `https://pattyshomemadegifts.com/${data.data.product.category[0].slug}/${data.data.product.slug}/` : ""}
      ogImage={data.data.product.productImage && data.data.product.productImage[0] ? `${process.env.GATSBY_FLOTIQ_BASE_URL}/image/400x0/${data.data.product.productImage[0].id}.${data.data.product.productImage[0].extension}` : ""}
      ogDescription={data.data.product.category[0].name}
      twitterDescription={data.data.product.category[0].name}
      metaTitle={data.data.product ? `${data.data.product.name}` : ""}
      metaCategory={data.data.product.category[0].name}
      metaDescription={data.data.product.description}
      metaPrice={data.data.product.price}
      metaStock={data.data.product.stock}
    />

    <div className="container details-page">

        <div class="breadcrumbs">
          <h2><a href="/">Categories</a> / <a href={`/${data.data.product.category[0].slug}`}>{data.data.product.category[0].name}</a> / {data.data.product.name}</h2>
        </div>

        <h1 className="with-underline">{data.data.product.name}</h1>

        <div className="product-details">
          <h2 className="with-underline product-details-heading">Product Details</h2>
          <div className="buynowinner">
            <span className="price">Price: ${data.data.product.price}</span><br/>
            {/* <a href="/"
              className="Product snipcart-add-item"
              data-item-id={data.data.product.slug}
              data-item-price={data.data.product.price}
              data-item-stock={data.data.product.stock}
              data-item-image={data.data.product.productImage && data.data.product.productImage[0] ? `${process.env.GATSBY_FLOTIQ_BASE_URL}/image/1920x0/${data.data.product.productImage[0].id}.${data.data.product.productImage[0].extension}` : ""} data-item-name={data.data.product.name}
              data-item-url={data.data.product ? `/${data.data.product.category[0].slug}/${data.data.product.slug}` : ""}
              data-item-custom1-name={data.data.product.options && data.data.product.options[0] ? `${data.data.product.options[0].optionName}` : ""}
              data-item-custom1-options={data.data.product.options && data.data.product.options[0] ? `${data.data.product.options[0].optionVariations}` : ""}
              data-item-custom2-name={data.data.product.options && data.data.product.options[1] ? `${data.data.product.options[1].optionName}` : ""}
              data-item-custom2-options={data.data.product.options && data.data.product.options[1] ? `${data.data.product.options[1].optionVariations}` : ""}
              data-item-custom3-name={data.data.product.options && data.data.product.options[2] ? `${data.data.product.options[2].optionName}` : ""}
              data-item-custom3-options={data.data.product.options && data.data.product.options[2] ? `${data.data.product.options[2].optionVariations}` : ""}
              data-item-custom4-name={data.data.product.options && data.data.product.options[3] ? `${data.data.product.options[3].optionName}` : ""}
              data-item-custom4-options={data.data.product.options && data.data.product.options[3] ? `${data.data.product.options[3].optionVariations}` : ""}
              data-item-custom5-name={data.data.product.options && data.data.product.options[4] ? `${data.data.product.options[4].optionName}` : ""}
              data-item-custom5-options={data.data.product.options && data.data.product.options[4] ? `${data.data.product.options[4].optionVariations}` : ""}
              data-item-custom6-name={data.data.product.options && data.data.product.options[5] ? `${data.data.product.options[5].optionName}` : ""}
              data-item-custom6-options={data.data.product.options && data.data.product.options[5] ? `${data.data.product.options[5].optionVariations}` : ""}
              data-item-custom7-name={data.data.product.options && data.data.product.options[6] ? `${data.data.product.options[6].optionName}` : ""}
              data-item-custom7-options={data.data.product.options && data.data.product.options[6] ? `${data.data.product.options[6].optionVariations}` : ""}
              data-item-custom8-name={data.data.product.options && data.data.product.options[7] ? `${data.data.product.options[7].optionName}` : ""}
              data-item-custom8-options={data.data.product.options && data.data.product.options[7] ? `${data.data.product.options[7].optionVariations}` : ""}
              data-item-custom9-name={data.data.product.options && data.data.product.options[8] ? `${data.data.product.options[8].optionName}` : ""}
              data-item-custom9-options={data.data.product.options && data.data.product.options[8] ? `${data.data.product.options[8].optionVariations}` : ""}
              data-item-custom10-name={data.data.product.options && data.data.product.options[9] ? `${data.data.product.options[9].optionName}` : ""}
              data-item-custom10-options={data.data.product.options && data.data.product.options[9] ? `${data.data.product.options[9].optionVariations}` : ""}
              data-item-custom11-name={data.data.product.options && data.data.product.options[10] ? `${data.data.product.options[10].optionName}` : ""}
              data-item-custom11-options={data.data.product.options && data.data.product.options[10] ? `${data.data.product.options[10].optionVariations}` : ""}
              data-item-custom12-name={data.data.product.options && data.data.product.options[11] ? `${data.data.product.options[11].optionName}` : ""}
              data-item-custom12-options={data.data.product.options && data.data.product.options[11] ? `${data.data.product.options[11].optionVariations}` : ""}
              data-item-custom13-name={data.data.product.options && data.data.product.options[12] ? `${data.data.product.options[12].optionName}` : ""}
              data-item-custom13-options={data.data.product.options && data.data.product.options[12] ? `${data.data.product.options[12].optionVariations}` : ""}
              data-item-custom14-name={data.data.product.options && data.data.product.options[13] ? `${data.data.product.options[13].optionName}` : ""}
              data-item-custom14-options={data.data.product.options && data.data.product.options[13] ? `${data.data.product.options[13].optionVariations}` : ""}
              data-item-custom15-name={data.data.product.options && data.data.product.options[14] ? `${data.data.product.options[14].optionName}` : ""}
              data-item-custom15-options={data.data.product.options && data.data.product.options[14] ? `${data.data.product.options[14].optionVariations}` : ""}
              data-item-custom16-name={data.data.product.options && data.data.product.options[15] ? `${data.data.product.options[15].optionName}` : ""}
              data-item-custom16-options={data.data.product.options && data.data.product.options[15] ? `${data.data.product.options[15].optionVariations}` : ""}
              data-item-custom17-name={data.data.product.options && data.data.product.options[16] ? `${data.data.product.options[16].optionName}` : ""}
              data-item-custom17-options={data.data.product.options && data.data.product.options[16] ? `${data.data.product.options[16].optionVariations}` : ""}
              data-item-custom18-name={data.data.product.options && data.data.product.options[17] ? `${data.data.product.options[17].optionName}` : ""}
              data-item-custom18-options={data.data.product.options && data.data.product.options[17] ? `${data.data.product.options[17].optionVariations}` : ""}
              data-item-custom19-name={data.data.product.options && data.data.product.options[18] ? `${data.data.product.options[18].optionName}` : ""}
              data-item-custom19-options={data.data.product.options && data.data.product.options[18] ? `${data.data.product.options[18].optionVariations}` : ""}
              data-item-custom20-name={data.data.product.options && data.data.product.options[19] ? `${data.data.product.options[19].optionName}` : ""}
              data-item-custom20-options={data.data.product.options && data.data.product.options[19] ? `${data.data.product.options[19].optionVariations}` : ""}
              data-item-custom21-name="Special comments"
              data-item-custom21-type="textarea"
            >
              <i className="fas fa-shopping-bag" /> {data.data.product.stock ? "Add to Cart" : "Special Order"}
            </a> */}
            <a className="btn" href="/contact" >Contact me to purchase</a>
            {data.data.product.stock ? <span className="stock"> Stock: {data.data.product.stock}</span> : <span className="stock"> Out of Stock</span>}
            <div dangerouslySetInnerHTML={{ __html: data.data.product.description }} /></div>
        </div>

        <div className="product-images">
          {
            data.data.product.productImage && data.data.product.productImage[0]  ? /*If has product image*/

              /* Old Method
                <div className="image img-magnifier-container">
                    <img id="productImage" alt={data.data.product.name} src={data.data.product.productImage && data.data.product.productImage[0] ? `${process.env.GATSBY_FLOTIQ_BASE_URL}/image/1920x0/${data.data.product.productImage[0].id}.${data.data.product.productImage[0].extension}` : ""} />
                </div>
              */

              <div className="Product-Image-Wrap">

                <LightgalleryProvider
                  onAfterSlide={() => {
                    console.log("onAfterSlide");
                  }}
                >

                  <PhotoItem image={data.data.product.productImage && data.data.product.productImage[0] ? `${process.env.GATSBY_FLOTIQ_BASE_URL}/image/1920x0/${data.data.product.productImage[0].id}.${data.data.product.productImage[0].extension}` : ""} alt={data.data.product.name} group="productImage" />

                </LightgalleryProvider>

              </div>

             : /* Else */

              <div className="no-image">No Image for this product.</div>

          }


          {
            data.data.product.productGallery && data.data.product.productGallery.length ? /*If has product image*/

              /* Old Method
                <Tabs>
                  <h3>Additional Pictures</h3>
                  {data.data.product.productGallery.map(items => (
                    <TabPanel key={items.id}>
                      <Tab><img
                          alt={data.data.product.name}
                          src={`${process.env.GATSBY_FLOTIQ_BASE_URL}/image/1920x0/${items.id}.${items.extension}`} /></Tab>
                    </TabPanel>
                  ))}
                  <TabList>
                    {data.data.product.productGallery.map(items => (
                      <Tab key={items.id}>
                        <img
                            alt={data.data.product.name}
                            src={`${process.env.GATSBY_FLOTIQ_BASE_URL}/image/1920x0/${items.id}.${items.extension}`} />
                      </Tab>
                    ))}
                  </TabList>
                </Tabs>
              */

              <div className="Product-Gallery-Wrap">

                <LightgalleryProvider
                  onAfterSlide={() => {
                    console.log("onAfterSlide");
                  }}
                >
                    {data.data.product.productGallery.map(items => (

                          <PhotoItem image={`${process.env.GATSBY_FLOTIQ_BASE_URL}/image/1920x0/${items.id}.${items.extension}`} alt={data.data.product.name} group="productGallery" />

                    ))}
                </LightgalleryProvider>

              </div>

            : /* Else */

            <div className="hidden">This div is hidden if no images are added to ProductGallery</div>
          }
        </div>
        <DisqusComments
          slug={data.data.product.slug}
          title={data.data.product.name}
          url={`https://pattyshomemadegifts.com/${data.data.product.category[0].slug}/${data.data.product.slug}/`}
        />
      </div>

</Layout >
)

export default ProductDetails

export const query = graphql`
  query productBySlug($slug: String!) {
    product(slug: {eq: $slug}) {
      id
      slug
      name
      price
      stock
      description
      productImage {
        id
        extension
      }
      productGallery {
        id
        extension
      }
      category {
        name
        slug
      }
      options {
        optionName
        optionVariations
      }
    }
}
`
